<template>
  <div class="outline-card" role="region" aria-label="Optional essay outline">
    <div
      class="outline-toggle"
      role="button"
      tabindex="0"
      :aria-expanded="String(isOutlineOpen)"
      aria-controls="outline-collapse"
      @click="toggleOutline"
      @keydown.enter.prevent="toggleOutline"
      @keydown.space.prevent="toggleOutline"
    >
      <div class="outline-copy">
        <p class="outline-title mb-0">Optional: Plan your essay</p>
        <p class="outline-subtext mb-0">
          Use this space to outline your ideas before you start writing
        </p>
      </div>
      <span class="outline-chevron" :class="{ 'is-open': isOutlineOpen }" aria-hidden="true"></span>
    </div>

    <b-collapse id="outline-collapse" v-model="isOutlineOpen" role="tabpanel">
      <div class="outline-body">
        <b-textarea
          class="no-scroll-bar textbox-border textbox"
          max-rows="12"
          rows="7"
          no-resize
          v-model="outline"
          placeholder="- Main argument\n- Evidence idea #1\n- Evidence idea #2"
        ></b-textarea>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  props: ["totalEmits", "outlineText"],
  emits: ["TimedOutline"],
  setup(props, { emit }) {
    const outline = ref(props.outlineText);
    const isOutlineOpen = ref(false);

    const toggleOutline = () => {
      isOutlineOpen.value = !isOutlineOpen.value;
    };

    watch(
      () => props.totalEmits,
      newEmit => {
        console.log(newEmit);
        if (newEmit === 1) {
          emit("TimedOutline", outline.value);
        }
      },
      { deep: true }
    );

    return { outline, isOutlineOpen, toggleOutline };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap");
.outline-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fcfcfd;
  overflow: hidden;
  padding: 0px;
}

.outline-toggle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.outline-toggle:hover {
  background: #f7f7fb;
  box-shadow: inset 0 0 0 1px rgba(17, 24, 39, 0.03);
}

.outline-card:hover .outline-toggle {
  background: #f7f7fb;
}

.outline-toggle:focus-visible {
  outline: 2px solid rgba(140, 48, 245, 0.35);
  outline-offset: 2px;
  border-radius: 10px;
}

.outline-copy {
  text-align: left;
  flex: 1 1 auto;
  min-width: 0;
}

.outline-title {
  color: var(--text-subtle, #6b7280);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
}

.outline-subtext {
  margin-top: 4px;
  color: var(--text-subtle, #8b90a0);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
}

.outline-chevron {
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  border-right: 2.5px solid #6b7280;
  border-bottom: 2.5px solid #6b7280;
  transform: rotate(45deg);
  margin-top: -2px;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.outline-toggle:hover .outline-chevron,
.outline-card:hover .outline-chevron {
  border-color: #4b5563;
}

.outline-chevron.is-open {
  transform: rotate(225deg);
}

.outline-body {
  padding: 0 18px 18px;
}

.textbox {
  width: 100%;
  font-family: "Nanum Pen Script", cursive;
  color: var(--text-normal, #18191f);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.textbox:focus {
  border-color: rgba(140, 48, 245, 0.45);
  box-shadow: 0 0 0 2px rgba(140, 48, 245, 0.12);
}
</style>
<style lang="sass" scoped src="@/assets/css/essayWriting.sass"></style>
